import React, { CSSProperties, HTMLProps, useMemo, useState } from "react";
import styled from "styled-components/macro";
import FieldTemplateWithError from "../FieldTemplateWithError";
import { fieldBase } from "../Form";
import { IMaskMixin } from "react-imask";

export interface InputProps extends fieldBase<string> {
  style?: CSSProperties;
  maxLength?: number;
  inputProps?: HTMLProps<HTMLInputElement>;
  mask?: string;
  onFocus?: (value: string) => void;
  onBlur?: (value: string) => void;
  dataQaId?: string
}

const InputInner = styled.input<any>`
  border: none;
  width: 100%;
  font: inherit;
  padding: 0;
  background: transparent;
  &::placeholder {
    color: var(--black-60);
  }
`;
const InputInnerWithMask = IMaskMixin(({ inputRef, ...props }: any) => (
  <InputInner {...props} ref={inputRef} />
)) as any;

const Input = (props: InputProps) => {
  const [active, setActive] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(e.target.value);
  };

  const setValue = (value: string) => {
    props.onChange?.(value);
  };

  const handleFocus = (e: React.ChangeEvent<HTMLInputElement>) => {
    setActive(true);
    props.onFocus?.(e.target.value);
  };

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    setActive(false);
    props.onBlur?.(e.target.value);
  };

  const { ref, as, ...inputProps } = props.inputProps || {};
  const InputForRender = useMemo(
    () => (props.mask ? InputInnerWithMask : InputInner),
    [props.mask]
  );
  return (
    <FieldTemplateWithError
      editabel={!props.readOnly}
      disable={props.disabled}
      className={props.className}
      active={active}
      style={props.style}
      error={props.error}
      errorText={props.errorText}
    >
      <InputForRender
        {...inputProps}
        value={props.value}
        onChange={handleChange}
        maxLength={props.maxLength}
        placeholder={props.placeholder}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={props.readOnly || props.disabled}
        mask={props.mask}
        onAccept={setValue}
        data-qa-id={props.dataQaId}
      />
    </FieldTemplateWithError>
  );
};

export default Input;
